import React, { HTMLAttributes, MouseEvent } from "react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { cn } from "helpers/style";
import styles from "./NavItem.module.scss";

type Props = {
  title: string;
  type?: "promo" | "discounts" | "isg" | string;
  active?: boolean;
  isCatalogOpened?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  onMouseEnter?: () => void;
  onmouseleave?: () => void;
  className?: string;
  employeeMode?: boolean;
} & HTMLAttributes<HTMLAnchorElement>;

/* todo: refactor with new next/link */
const NavItem = React.forwardRef<HTMLAnchorElement, Props>(
  (
    {
      active,
      title,
      type,
      onClick,
      onMouseEnter,
      isCatalogOpened,
      onmouseleave,
      className,
      employeeMode,
      ...props
    },
    ref
  ) => {
    const blueLinks = useFeatureIsOn("ex_blueblocksheader");

    return (
      <a
        ref={ref}
        className={cn([
          styles.item,
          type && styles[type],
          isCatalogOpened && !active && styles.catalogOpen,
          active && styles.active,
          employeeMode && styles.employeeMode,
          blueLinks && styles.blue,
          className,
        ])}
        type={type}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onmouseleave}
        {...props}
      >
        <span>{title}</span>
      </a>
    );
  }
);

export default NavItem;
